module.exports = __webpack_public_path__ + "static/media/icons-alpha-40.343b2ea8.png";